<template>
  <div class="wrap">
    <div class="title">申办业务个人信息使用授权书</div>
    <div class="cont">
      <p>
        授权人（即申请人），本人同意并不可撤销地授权北京佳付通网络科技有限公司以及其运营的佳付通平台（以下简称“平台”），在本次业务过程中，基于约定用途(申办您需求的业务)，享有下列权限：(申办您需求的业务)，享有下列权限：
      </p>
      <p>
        1、授权使用范围：授权平台采集、留存本人的姓名、身份证号、手机号（以下简称“个人信息”），用于您申办本次业务的相关用途。
      </p>
      <p>
        2、授权使用目的与使用方式：将您的个人信息用于您申办业务的需求，基于产品方要求，以及平台日常运营使用。
      </p>
      <p>
        3、授权平台以及第三方短信验证服务机构对申请人提交的手机号进行验证核实。
      </p>
      <p>
        4、授权使用期限：自本授权书签署之日起，至相关业务终止。
      </p>
      <p>
        5、授权本平台对本人信息进行合法、合理披露，如公安机关、司法机关、相关监管部门依职权调取，发卡行依业务需求调取。
      </p>
      <p class="weight">
          特别声明：
      </p>
      <p class="weight">
          授权人本人承诺本授权效力具有独立性，不因其他合同的任何条款无效而失效。
      </p>
      <p class="weight">
          授权人授权时不存在任何被胁迫、误解、有失公平等情况，完全处于本人真实与自愿的意思表示。
      </p>
      <p class="weight">
          本授权书为电子格式，自申请人勾选“同意”或其他类似确认的电子按钮后，自动生成并发生法律效力（电子签章不作为本授权书生效的必要签署形式）。
      </p>
      <p>
          （以下无正文）
      </p>
    </div>
    <img src="../../assets/img/backPic.png" alt="" @click="back" class="pic">
  </div>
</template>

<script>
export default {
    created() {
        document.title = "授权协议";
    },
    methods: {
      back(){
        this.$router.go(-1)
      }
    },
};
</script>

<style scoped>
.title {
  font-weight: bold;
  font-size: 18px;
  text-align: center;
}
.wrap {
  margin-top: 15px;
  padding: 0 10px;
}
.cont {
  margin-top: 20px;
  margin-bottom: 20px;
}
p {
  text-indent: 32px;
  line-height: 28px;
}
.weight{
    font-weight: bold;
}
.pic{
    position: fixed;
    left: 0;
    bottom: 40%;
    opacity: .7;
}
</style>